import * as selectors from './selectors';

import * as actions from './actions';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { getHonoraryNote, getHonoraryNoteTypeCodes, saveHonoraryNote as saveHonoraryNoteApi, saveHonoraryNoteLine as saveHonoraryNoteLineApi, deleteHonoraryNoteLine, deleteHonoraryNote } from '../../utils/api/honoraryNoteApi';

import { DetailsHonoraryNoteActionTypes } from './types';
import { SagaIterator } from 'redux-saga';

function* handleFetchHonoraryNotes(action: ReturnType<typeof actions.fetchHonoraryNotes>): SagaIterator {
  try {
    const res = yield call(getHonoraryNote, action.payload.instructionId);

    if (!res.data) {
      yield put(actions.fetchHonoraryNoteError(JSON.stringify(res.response)));
    } else {
      yield put(actions.fetchHonoraryNoteSuccess(res.data));
      if (res.data.length > 0) {
        const honoraryNoteId = res.data[0].honoraryNoteId;
        yield put(actions.selectHonoraryNote(honoraryNoteId));
      }
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.fetchHonoraryNoteError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(actions.fetchHonoraryNoteError('An unknown error occured.'));
    }
  }
}

function* handleFetchHonoraryNoteTypeCodes(action: ReturnType<typeof actions.fetchHonoraryNoteTypeCodes>): SagaIterator {
  try {
    const res = yield call(getHonoraryNoteTypeCodes);

    if (!res.data) {
      yield put(actions.fetchHonoraryNoteTypeCodesError(JSON.stringify(res.response)));
    } else {
      yield put(actions.fetchHonoraryNoteTypeCodesSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.fetchHonoraryNoteTypeCodesError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(actions.fetchHonoraryNoteTypeCodesError('An unknown error occured.'));
    }
  }
}

function* handleSaveHonoraryNote(action: ReturnType<typeof actions.saveHonoraryNote>): SagaIterator {
  try {
    const res = yield call(saveHonoraryNoteApi, action.payload.honoraryNote);

    if (!res.data) {
      yield put(actions.saveHonoraryNoteError(JSON.stringify(res.response)));
    } else {
      yield put(actions.saveHonoraryNoteSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.saveHonoraryNoteError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(actions.saveHonoraryNoteError('An unknown error occured.'));
    }
  }
}

function* handleAddHonoraryNoteLine(action: ReturnType<typeof actions.addHonoraryNoteLine>): SagaIterator {
  try {
    const honoraryNoteLine = { ...action.payload.honoraryNoteLine };
    if (honoraryNoteLine.honoraryNoteId === 0) {
      let honoraryNote = yield select(selectors.selectedHonoraryNote);
      honoraryNote.caseCode = action.payload.caseCode;
      const result = yield call(saveHonoraryNoteApi, honoraryNote);

      if (!result.data) {
        yield put(actions.saveHonoraryNoteError(JSON.stringify(result.response)));
      } else {
        yield put(actions.saveHonoraryNoteSuccess(result.data));
        honoraryNote = result.data;
        honoraryNoteLine.honoraryNoteId = honoraryNote.honoraryNoteId;
      }
    }

    const res = yield call(saveHonoraryNoteLineApi, honoraryNoteLine);

    if (!res.data) {
      yield put(actions.addHonoraryNoteLineError(JSON.stringify(res.response)));
    } else {
      yield put(actions.addHonoraryNoteLineSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.addHonoraryNoteLineError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(actions.addHonoraryNoteLineError('An unknown error occured.'));
    }
  }
}

function* handleDeleteHonoraryNote(action: ReturnType<typeof actions.deleteHonoraryNote>): SagaIterator {
  try {
    const res = yield call(deleteHonoraryNote, action.payload.honoraryNoteId);

    if (!res.data) {
      yield put(actions.deleteHonoraryNoteError(JSON.stringify(res.response)));
    } else {
      yield put(actions.deleteHonoraryNoteSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.addHonoraryNoteLineError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(actions.addHonoraryNoteLineError('An unknown error occured.'));
    }
  }
}

function* handleDeleteHonoraryNoteLine(action: ReturnType<typeof actions.deleteHonoraryNoteLine>): SagaIterator {
  try {
    const res = yield call(deleteHonoraryNoteLine, action.payload.honoraryNoteLineId);

    if (!res.data) {
      yield put(actions.deleteHonoraryNoteLineError(JSON.stringify(res.response)));
    } else {
      yield put(actions.deleteHonoraryNoteLineSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.addHonoraryNoteLineError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(actions.addHonoraryNoteLineError('An unknown error occured.'));
    }
  }
}
function* handleSelectHonoraryNote(action: ReturnType<typeof actions.selectHonoraryNote>): SagaIterator {
    const honoraryNote = yield select(selectors.selectedHonoraryNote);
    yield put(actions.updateHonoraryStructuredMessage(honoraryNote.structuredMessage));
}

function* watchDetailsHonoraryNote() {
  yield takeEvery(DetailsHonoraryNoteActionTypes.FETCH_HONORARY_NOTES, handleFetchHonoraryNotes);
  yield takeEvery(DetailsHonoraryNoteActionTypes.FETCH_HONORARY_NOTE_TYPECODES, handleFetchHonoraryNoteTypeCodes);
  yield takeEvery(DetailsHonoraryNoteActionTypes.SAVE_HONORARY_NOTE, handleSaveHonoraryNote);
  yield takeEvery(DetailsHonoraryNoteActionTypes.ADD_HONORARY_NOTE_LINE, handleAddHonoraryNoteLine);
  yield takeEvery(DetailsHonoraryNoteActionTypes.DELETE_HONORARY_NOTE, handleDeleteHonoraryNote);
  yield takeEvery(DetailsHonoraryNoteActionTypes.DELETE_HONORARY_NOTE_LINE, handleDeleteHonoraryNoteLine);
  yield takeEvery(DetailsHonoraryNoteActionTypes.SELECT_HONORARY_NOTE, handleSelectHonoraryNote);
}

function* detailsHonoraryNoteSaga() {
  yield all([fork(watchDetailsHonoraryNote)]);
}

export default detailsHonoraryNoteSaga;
